import styled from "styled-components";
import BenefitsContent from "@/components/old-sessions-house/SessionsHouseBenefitsContent";
import EnquireContent from "@/components/old-sessions-house/SessionsHouseEnquireContent";
import SessionsHouseHeroContent from "@/components/old-sessions-house/SessionsHouseHero";
import ImagesContent from "@/components/old-sessions-house/SessionsHouseImagesContent";
import LoungeContent from "@/components/old-sessions-house/SessionsHouseLoungeContent";
import MoreBenefitsContent from "@/components/old-sessions-house/SessionsHouseMoreBenefitsContent";
import SessionsHouseSquares from "@/components/old-sessions-house/SessionsHouseSquares";
import RxPageLayout from "@/components/ui/display/RxPageLayout";
import RxStickyButtonStrip from "@/components/ui/inputs/RxStickyButtonStrip";
import { colours } from "@/utils";
import RxScrollTo, { useScrollTo } from "@/components/RxScrollTo";
import React, { useState } from "react";
import { useRouter } from "next/router";
import Modal from "@/components/Modal";
import MarketingFormContainer from "@/components/marketing/MarketingFormContainer";
import SessionsHouseForm from "@/components/old-sessions-house/SessionsHouseForm";

const benefits = [
  {
    colour: colours.marketingPeach,
    copy: "At Old Sessions House, you’ll find a range of spaces designed to inspire both productivity and relaxation. Whether you’re networking, socialising, or unwinding, you can enjoy the café, bar, and rooftop terrace with a pool. For focused work or collaboration, the dedicated workspaces are perfect for getting things done. From March, you’ll also have exclusive access to the AllBright Lounge—an inviting, vibrant space where you can continue informal networking and build meaningful connections with fellow members.",
    image: "/images/old-sessions-house/interior-chairs.jpg",
    title: "Exclusive Spaces to Connect, Relax, and Work",
  },
  {
    colour: colours.marketingPurple,
    copy: "AllBright’s renowned networking opportunities and community events take place in person at Old Sessions House and online, with 330+ events annually. You’ll also have access to a range of events hosted by Old Sessions House, centred around the pillars of Work, Live, and Play.",
    image: "/images/old-sessions-house/handshake.jpg",
    textColour: colours.shell,
    title: "A Full Calendar of Events",
  },
  {
    colour: colours.marketingYellowPale,
    copy: "As a member, you can bring one guest during the day, five guests after 4pm, and up to four guests on Fridays—perfect for making the most of our Founder Fridays.",
    image: "/images/old-sessions-house/cafe.jpg",
    title: "Invite Guests to Join You at Old Sessions House",
  },
  {
    colour: colours.marketingTealPale,
    copy: "As part of your membership, you’ll have online access to 200+ AllBright Academy courses, on-demand events, Mentor Matching, and a vibrant network of ambitious women.",
    image: "/images/old-sessions-house/desktop.jpg",
    textColour: colours.shell,
    title: "Access AllBright Virtual—Anytime, Anywhere",
  },
];

const OldSessionsHouse = () => {
  const router = useRouter();
  const scrollRefBenefits = useScrollTo(router.query.type === "benefits");
  const scrollRefEnquire = useScrollTo(router.query.type === "enquire");
  const [formModalOpen, setFormModalOpen] = useState(false);

  const formTabs = [
    {
      activeColour: colours.teal,
      content: <SessionsHouseForm type="Register interest" />,
      title: "Interested in joining us in person?",
    },
  ];

  return (
    <RxPageLayout>
      {formModalOpen && (
        <>
          <Modal
            onClose={() => setFormModalOpen(false)}
            colour={colours.shellHighlight}
          >
            <S.ModalContent>
              <MarketingFormContainer
                initialTab={formTabs[0].title}
                tabs={formTabs}
              />
            </S.ModalContent>
          </Modal>
        </>
      )}
      <SessionsHouseHeroContent />
      <BenefitsContent />
      <RxScrollTo ref={scrollRefBenefits} />
      {benefits.map((benefit, i) => (
        <SessionsHouseSquares
          {...benefit}
          reverse={i % 2 !== 0}
          key={benefit.title}
        />
      ))}
      <MoreBenefitsContent formModalOpen={() => setFormModalOpen(true)} />
      <LoungeContent />
      <ImagesContent />
      <RxScrollTo ref={scrollRefEnquire} />
      <EnquireContent formModalOpen={() => setFormModalOpen(true)} />
      <RxStickyButtonStrip
        buttonText="Register interest"
        name="enquire_now"
        onClick={() => setFormModalOpen(true)}
      />
    </RxPageLayout>
  );
};

const S = () => {};

S.ModalContent = styled.div`
  margin: 0;
`;

export default OldSessionsHouse;
